import React, { createContext, useState, useEffect } from 'react';
import translations from "./translations";
import config from "../config/config";

export const LanguageContext = createContext();

const LanguageProvider = ({ children }) => {
    const [currentPage, setCurrentPage] = useState('home');
    const [language, setLanguage] = useState(
        localStorage.getItem('language') || 'de'
    );

    useEffect(() => {
        localStorage.setItem('language', language);
    }, [language]);

    return (
        <LanguageContext.Provider value={{ language, setLanguage, translations, config, currentPage, setCurrentPage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export default LanguageProvider;